export default __webpack_public_path__ + "static/media/bicycle_dark.678bc7a6.png";